import Layout from "@/layout/views/index";
const logsList = [
  {
    path: "/logs",
    component: resolve => require(["@/views/logs/logs.vue"], resolve),
    name: "日志",
    meta: {
      title: "日志",
      affix: true
    }
  },
  {
    path: "/monitor/operation",
    component: resolve => require(["@/views/logs/cron.vue"], resolve),
    name: "计划日志",
    meta: {
      title: "计划日志",
      affix: true
    }
  },
  {
    path: "/monitor/logininfor",
    component: resolve => require(["@/views/logs/login.vue"], resolve),
    name: "登录日志",
    meta: {
      title: "计划日志",
      affix: true
    }
  },
  {
    path: "/monitor/operlog",
    component: resolve => require(["@/views/logs/operation.vue"], resolve),
    name: "操作日志",
    meta: {
      title: "计划日志",
      affix: true
    }
  }
];
export default logsList;
